import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import { gql } from '@apollo/client';
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect } from 'react-redux';
import { change } from 'redux-form'
import { injectIntl } from 'react-intl';

import ImageUploadComponent from '../../ImageUploadComponent/ImageUploadComponent';
import CommonImageDisplay from '../../CommonImageDisplay/CommomImageDisplay';

import { logouploadDir } from '../../../../config';
import { photosShow } from '../../../../helpers/photosShow';
import { withQuery } from '../../../../hoc/withGraphql';
import messages from '../../../../locale/jsonMessages';
import { doRemoveEmailLogo, doUploadEmailLogo, startEmailLogoUploaderLoader, stopEmailLogoUploaderLoader } from '../../../../actions/siteadmin/manageLogo';
import { demoRestriction } from '../../../../helpers/DemoRestriction/demoRestriction';

import s from './EmailLogoUploader.css';
import bt from '../../../../components/commonStyle.css';

class EmailLogoUploader extends React.Component {

  static propTypes = {
    emailLogoUploaderLoading: PropTypes.bool,
    doRemoveEmailLogo: PropTypes.any.isRequired,
    getLogoData: PropTypes.shape({
      loading: PropTypes.bool,
      getEmailLogo: PropTypes.shape({
        name: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired
      })
    })
  };

  static defaultProps = {
    getLogoData: {
      loading: true
    },
    emailLogoUploaderLoading: false
  };

  success = async (file, fromServer) => {
    const { doUploadEmailLogo, getLogoData: { loading, getEmailLogo }, change, startEmailLogoUploaderLoader, stopEmailLogoUploaderLoader, demoRestriction } = this.props;
    let fileName, oldPicture, filePath;
    fileName = fromServer?.file?.filename;
    oldPicture = getEmailLogo != null ? getEmailLogo.value : null;
    filePath = fromServer?.file?.path;
    const isRestrict = await demoRestriction({});
    if (isRestrict) return;
    startEmailLogoUploaderLoader();
    doUploadEmailLogo(fileName, filePath, oldPicture);
    await change('SiteSettingsForm', 'emailLogo', fileName);
    stopEmailLogoUploaderLoader();
  }

  render() {
    const { getLogoData: { loading, getEmailLogo }, doRemoveEmailLogo, emailLogoUploaderLoading } = this.props;
    const { formatMessage } = this.props.intl;
    let path = photosShow(logouploadDir);
    return (
      <div>
        <CommonImageDisplay
          loading={loading}
          image={getEmailLogo?.value && path + getEmailLogo?.value}
          isDefaultPic={getEmailLogo?.value ? false : true}
          loader={emailLogoUploaderLoading}
          isDelete={false}
        />
        <ImageUploadComponent
          defaultMessage={formatMessage(messages.clickHeretoUploadLogo)}
          componentConfig={{
            iconFiletypes: ['.jpg', '.png', '.jpeg'],
            multiple: false,
            showFiletypeIcon: false,
            postUrl: '/uploadEmailLogo'
          }}
          loaderName={'emailLogoUploaderLoading'}
          success={this.success}
          className={bt.spaceTop3}
        />
      </div>
    );
  }
}

const mapState = (state) => ({
  emailLogoUploaderLoading: state?.loader?.emailLogoUploaderLoading
});

const mapDispatch = {
  doRemoveEmailLogo,
  doUploadEmailLogo,
  startEmailLogoUploaderLoader,
  stopEmailLogoUploaderLoader,
  change,
  demoRestriction
};

export default compose(
  injectIntl,
  withStyles(s, bt),
  connect(mapState, mapDispatch),
  withQuery(gql`
          query getEmailLogo{
            getEmailLogo {
            id
          title
          name
          value
          type
        }
      }
          `, {
    name: 'getLogoData',
    options: {
      ssr: false
    }
  }),
)(EmailLogoUploader);